import React from 'react'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import styles from '../../modalUnitConsumer.module.css'

type SectionProps = {
  icon?: string
  image?: string
  title: string
  description?: string
  extra?: React.ReactNode
  children: React.ReactNode
}

export const FormSection = ({icon, image, title, description, extra, children}: SectionProps) => (
  <section className={styles.section}>
    <header className={styles.sectionHeader}>
      <span className={styles.sectionIcon}>
        {image ? (
          <img src={image} alt='' />
        ) : icon ? (
          <KTSVG path={icon} className='svg-icon-2 svg-icon-primary' />
        ) : null}
      </span>
      <div>
        <h4 className={styles.sectionTitle}>{title}</h4>
        {description && <span className={styles.sectionDescription}>{description}</span>}
      </div>
      {extra && <div className={styles.sectionExtra}>{extra}</div>}
    </header>
    <div className={styles.sectionBody}>{children}</div>
  </section>
)

type LabelProps = {
  children: React.ReactNode
  hint?: string
  required?: boolean
  htmlFor?: string
}

export const FieldLabel = ({children, hint, required, htmlFor}: LabelProps) => (
  <label className={styles.label} htmlFor={htmlFor}>
    <span className={required ? styles.required : undefined}>{children}</span>
    {hint && (
      <span className={styles.hint} title={hint}>
        <KTSVG
          path='/media/icons/duotune/general/gen045.svg'
          className='svg-icon-6 svg-icon-muted'
        />
      </span>
    )}
  </label>
)

export const FieldError = ({show, children}: {show: boolean; children: React.ReactNode}) =>
  show ? <div className={styles.error}>{children}</div> : null
